"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Dashboard;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var CreateButton_1 = __importDefault(require("@components/Buttons/CreateButton/CreateButton"));
var NewGDDForm_1 = __importDefault(require("@components/Forms/GddForm/NewGDDForm"));
var ExistingGDDsList_1 = __importDefault(require("@components/Lists/ExistingGDDsList/ExistingGDDsList"));
var dashboardLocalisation_1 = require("./localisation/dashboardLocalisation");
var useCurrentLanguage_1 = require("@hooks/useCurrentLanguage");
var Profile_1 = __importDefault(require("@components/Profile/Profile"));
function Dashboard() {
    var _a = (0, react_1.useState)(false), isFormVisible = _a[0], setFormVisible = _a[1];
    var currentLanguage = (0, useCurrentLanguage_1.useCurrentLanguage)();
    var loc = dashboardLocalisation_1.dashboardTranslator[currentLanguage];
    function setVisible() {
        setFormVisible(true);
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                }, children: [(0, jsx_runtime_1.jsx)(ExistingGDDsList_1.default, {}), (0, jsx_runtime_1.jsx)(CreateButton_1.default, { action: setVisible, title: loc.createButton })] }), (0, jsx_runtime_1.jsx)(NewGDDForm_1.default, { isVisible: isFormVisible, setVisible: setFormVisible }), (0, jsx_runtime_1.jsx)(Profile_1.default, {})] }));
}
